import * as types from './mutation-types'
// import api from '../api'
import * as firebase from 'firebase'

// export const loginUser = ({ commit }) => {
//   auth.signInAnonymously().catch(function (error) {
//     // Handle Errors here.
//     return false
//   })
// }

export const signUpUser = ({ commit }, payload) => {
  commit(types.INCREMENT_LOADING_PROGRESS)
  commit(types.STORE_CLEAR_ERROR)

  firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
    .then(
      user => {
        commit(types.RESET_LOADING_PROGRESS)
        commit(types.STORE_FETCHED_USER, user.uid)
        commit(types.LOGIN_USER)

        const newUser = {
          id: user.uid
        }
        console.log('NewUser:', newUser)
      }
    )
    .catch(
      error => {
        commit(types.RESET_LOADING_PROGRESS)
        commit(types.STORE_FETCHED_ERROR, error)
        console.log(error)
      }
    )
}

export const signInUser = ({ commit }, payload) => {
  commit(types.INCREMENT_LOADING_PROGRESS)
  commit(types.STORE_CLEAR_ERROR)

  firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
    .then(
    user => {
      commit(types.RESET_LOADING_PROGRESS)
      commit(types.STORE_FETCHED_USER, user.uid)
      commit(types.LOGIN_USER)

      const loginUser = {
        id: user.uid
      }
      console.log('LoginUser:', user.uid)
    }
    )
    .catch(
    error => {
      commit(types.RESET_LOADING_PROGRESS)
      commit(types.STORE_FETCHED_ERROR, error)
      console.log(error)
    }
    )
}



// WEBPACK FOOTER //
// ./src/store/actions.js